import { render, staticRenderFns } from "./TerminalRule.vue?vue&type=template&id=f4d84d82&"
import script from "./TerminalRule.vue?vue&type=script&lang=js&"
export * from "./TerminalRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports